import { FunctionComponent, useMemo } from 'react'
import { ContainerProps } from './types'
import useStyles from './styles'
import { SmartToast } from '../SmartToast'
import { createChainedFunction } from '@/utils/createChainedFunction'

export const Container: FunctionComponent<ContainerProps> = ({
  position,
  toastItems,
  onCloseToast,
  toHide,
}) => {
  const styles = useStyles()

  const positionStyle = useMemo(() => {
    const positionToStyle = {
      'top-left': styles.topLeft,
      'top-right': styles.topRight,
      'bottom-left': styles.bottomLeft,
      'bottom-right': styles.bottomRight,
    } as const

    return positionToStyle[position] || null
  }, [styles, position])

  if (!toastItems.length) return null

  return (
    <div css={[styles.container, positionStyle]}>
      {toastItems.map((toastItem, index) => {
        const {
          message,
          payload: { type, position, autoClose, messageId, onClose, ...rest },
        } = toastItem
        return (
          <SmartToast
            key={messageId}
            hide={toHide.includes(messageId)}
            onClose={createChainedFunction(
              () => onCloseToast(toastItem, index),
              onClose,
            )}
            containerPosition={position}
            message={message}
            {...rest}
          />
        )
      })}
    </div>
  )
}
